import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BannerModule } from "@obg/ngx.ui.common";

import { CarouselMediaBannerWrapperComponent } from "./carousel-media-banner-wrapper.component";
@NgModule({
	imports: [CommonModule, BannerModule],
	declarations: [CarouselMediaBannerWrapperComponent],
	exports: [CarouselMediaBannerWrapperComponent],
})
export class CarouselMediaBannerWrapperModule {}
